import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import http from '../../utils/api/http';

export const getFaqs = createAsyncThunk(
    'faq/getFaqs',
    async ({ name, page = 1, limit = 9 }) => {
        const { data } = await http.get(
            `api/v1/faqs?title=${name}&page=${page}&limit=${limit}`,
        );
        return data;
    },
);

export const getFaqById = createAsyncThunk('faq/getFaqById', async (id) => {
    const { data } = await http.get(`api/v1/faqs/${id}`);
    return data.data;
});

export const createFaq = createAsyncThunk(
    'faq/createFaq',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/faqs', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const editFaq = createAsyncThunk(
    'faq/editFaq',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/faqs/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteFaq = createAsyncThunk('faq/deleteFaq', async (id) => {
    await http.delete(`api/v1/faqs/${id}`);
});

export const getFaqsGroups = createAsyncThunk('faq/getFaqsGroups', async () => {
    const { data } = await http.get(`api/v1/faqs/groups`);
    return data.data;
});

export const createFaqsGroup = createAsyncThunk(
    'faq/createFaqsGroup',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.post('api/v1/faqs/groups', body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const editFaqsGroup = createAsyncThunk(
    'faq/editFaqsGroup',
    async ({ id, body }, { rejectWithValue }) => {
        try {
            const { data } = await http.put(`api/v1/faqs/groups/${id}`, body);
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

export const deleteFaqsGroup = createAsyncThunk(
    'faq/deleteFaqsGroup',
    async (id) => {
        await http.delete(`api/v1/faqs/groups/${id}`);
    },
);

export const reorderFaqsGroups = createAsyncThunk(
    'faq/reorderFaqsGroups',
    async (body, { rejectWithValue }) => {
        try {
            const { data } = await http.put(
                `api/v1/faqs/groups/positions`,
                body,
            );
            return data.data;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    },
);

const initialState = {
    faqLoadingStatus: 'idle',
    faqsLoadingStatus: 'idle',
    faqsGroupsLoadingStatus: 'idle',
    faqs: [],
    faq: {},
    groups: [],
    meta: {},
    links: [],
    errors: {},
};

export const faqSlice = createSlice({
    name: 'faq',
    initialState,
    reducers: {
        resetFaq(state) {
            state.faq = {};
        },
    },
    extraReducers: {
        [getFaqs.pending]: (state, action) => {
            state.faqsLoadingStatus = 'loading';
        },
        [getFaqs.fulfilled]: (state, action) => {
            state.faqsLoadingStatus = 'succeeded';
            state.faqs = action.payload.data;
            state.links = action.payload.links;
            state.meta = action.payload.meta;
        },
        [getFaqs.rejected]: (state, action) => {
            state.faqsLoadingStatus = 'failed';
        },
        [getFaqById.pending]: (state, action) => {
            state.faqLoadingStatus = 'loading';
        },
        [getFaqById.fulfilled]: (state, action) => {
            state.faqLoadingStatus = 'succeeded';
            state.faq = action.payload;
        },
        [getFaqById.rejected]: (state, action) => {
            state.faqLoadingStatus = 'failed';
            state.errors = action.error;
        },
        [getFaqsGroups.pending]: (state, action) => {
            state.faqsGroupsLoadingStatus = 'loading';
        },
        [getFaqsGroups.fulfilled]: (state, action) => {
            state.faqsGroupsLoadingStatus = 'succeeded';
            state.groups = action.payload;
        },
        [getFaqsGroups.rejected]: (state, action) => {
            state.faqsGroupsLoadingStatus = 'failed';
        },
    },
});

/* Selectors */
export const allFaqs = (state) => state.faq.faqs;
export const oneFaq = (state) => state.faq.faq;
export const faqLoadingStatus = (state) => state.faq.faqLoadingStatus;
export const faqsLoadingStatus = (state) => state.faq.faqsLoadingStatus;
export const allFaqsGroups = (state) => state.faq.groups;
export const faqsGroupsLoadingStatus = (state) =>
    state.faq.faqsGroupsLoadingStatus;
export const faqsMeta = (state) => state.faq.meta;

export const { resetFaq } = faqSlice.actions;

export default faqSlice.reducer;
